module.exports = __webpack_public_path__ + "img/81000.11add579.jpg";